import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import Layout from "../Layout"
import { GestorForm } from "../modais"
class GestoresEditForm extends Component {
  constructor() {
    super()
    this.onSuccess = this.onSuccess.bind(this)
  }
  onSuccess() {
    this.props.history.push("/gestores")
  }
  render() {
    return (
      <Layout tabActive="Gestores de contrato">
        <GestorForm isEditing={true} callBackGestores={this.onSuccess} />
      </Layout>
    )
  }
}
export default withRouter(GestoresEditForm)



// WEBPACK FOOTER //
// ./src/views/gestores/GestoresEditForm.js